import React from "react";
import "./About.css";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();

  return (
    <div id="about">
      <div className="section-gap"></div>
      <section className="about wrapper">
        <div className="about-image">
          <img src="/assets/developer2.png" alt="developer" loading="lazy" />
        </div>
        <div className="about-right">
          <h2 className="section-title">{t("Om Mig")}</h2>
          <p className="gray">
            {t(
              "Jeg er full-stack-udvikler og AI-specialist med en baggrund i elektroteknik og har boet i Danmark i 15 år. Jeg har gennemført mere end 20 projekter og et intensivt 10-måneders full-stack-bootcamp, suppleret med formel uddannelse i anvendt AI. Jeg bygger end-to-end webapplikationer, integrerer moderne AI-modeller i praktiske løsninger og arbejder effektivt i tværfaglige teams. Jeg tager ansvar, kommunikerer klart og løser komplekse tekniske udfordringer med fokus på eksekvering og kvalitet."
            )}
          </p>
          <div className="two_ul_container">
            <ul className="about-list">
              <li>{t("Navn")} :</li>
              <li>{t("Mobil")} :</li>
              <li>{t("Email")} :</li>
              <li>{t("Bopæl")} :</li>
              <li>{t("Sprog")} :</li>
            </ul>
            <ul className="answer-list">
              <li>Arash Abdollahi</li>
              <li>22 61 20 22</li>
              <li>arash8877@gmail.com</li>
              <li>Virum</li>
              <li>{t("Dansk - Engelsk")}</li>
            </ul>
          </div>
          <a
            href="/assets/CV-Arash.pdf"
            download="CV-Arash.pdf"
            target="_blank"
            id="cv-btn"
          >
            Download CV
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
